import { LogoHolder } from "nq-component";
import classNames from "../../classNames";
import React from "react";

const defaultProps = {
  navigateIcon: "bi bi-list",
};

function NavBar2({
  className,
  onClickNavigate,
  navigateIcon,
  logo,
  title,
  action,
  user,
}) {
  const classes = classNames(
    className,
    "navbar navbar-expand-lg navbar-light bg-white"
  );
  return (
    <nav className={classes}>
      <div className="container-fluid">
        <button
          onClick={onClickNavigate}
          type="button"
          className="btn btn-sm btn-link fs-4 ps-0 text-dark"
        >
          <i className={navigateIcon} style={{ color: "#D18237" }}></i>
          {logo && (
            <img
              className="w-auto ms-3"
              src={logo}
              height="40"
              alt="title-logo"
            />
          )}
        </button>

        <div className="position-relative" style={{ margin: "0 auto" }}>
          <i
            className="bi bi-search position-absolute"
            style={{
              zIndex: 2,
              width: "50px",
              height: "50px",
              lineHeight: "47px",
              textAlign: "center",
              color: "gray",
            }}
          />
          <input
            type="search"
            className="search-nav form-control rounded-pill ps-5 "
            placeholder="Search for employee name, id, keyword"
            style={{
              width: "58vh",
              height: "45px",
              backgroundColor: "#EEEEEE",
            }}
          />
        </div>

        <div className="d-flex align-items-center">
          {/* {logo && (
            <img className="w-auto" src={logo} height="40" alt="title-logo" />
          )} */}
          {title && <h6 className="fw-bold m-0 ms-2">{title}</h6>}
        </div>

        <i
          className="bi bi-bell-fill"
          style={{ color: "#D18237", cursor: "pointer" }}
        ></i>

        {/* {(action && action()) || (
          <LogoHolder
            className="bg-dark"
            textClassName="text-white"
            logo={user?.picture}
            name={user?.username}
            width={45}
            height={45}
          />
        )} */}
      </div>
    </nav>
  );
}

NavBar2.defaultProps = defaultProps;
export default NavBar2;
